<template>
    <section class="relative z-10 bg-blue-100 self-gutter-y rounded-b-2xl">
        <div class="self-gutter">
            <div class="self-content">
                <div class="pt-24 pb-40 sm:pt-48">
                    <div class="flex flex-wrap flex-1 -mx-8 -mt-12 md:flex-nowrap" v-html="$store.getters.getWebContents.blocks.join('')"></div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>

export default {
    name: 'MoreInfoBlock'
}
</script>

<style scoped>

</style>
